
import { useEffect } from "react";
import { useLocation } from "@reach/router";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. Tenta scrollar a janela principal (padrão)
    window.scrollTo(0, 0);

    // 2. Tenta scrollar o container principal do Gatsby (ID padrão)
    const gatsbyContainer = document.getElementById("___gatsby");
    if (gatsbyContainer) {
      gatsbyContainer.scrollTo(0, 0);
    }

    // 3. Tenta scrollar o body e html (caso haja CSS de overflow neles)
    document.body.scrollTo(0, 0);
    document.documentElement.scrollTo(0, 0);

  }, [pathname]);

  return null;
};

export default ScrollToTop;